(function () {
  'use strict';

  let globalHandlersBound = false;
  const datasheetPreviewMobileQuery = window.matchMedia('(max-width: 767px)');

  function getState(container) {
    if (!container.energyInfoState) {
      container.energyInfoState = {
        activeModalTrigger: null
      };
    }

    return container.energyInfoState;
  }

  function getPreview(container, type) {
    return container.querySelector(`[data-energy-preview="${type}"]`);
  }

  function getModal(container, type) {
    return container.querySelector(`[data-energy-modal="${type}"]`);
  }

  function setPreviewVisibility(preview, visible) {
    if (!preview) return;

    preview.classList.toggle('is-visible', visible);
    preview.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function setModalVisibility(modal, visible) {
    if (!modal) return;

    modal.hidden = !visible;
    modal.classList.toggle('is-visible', visible);
    modal.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function hasVisibleModal(container) {
    return Array.from(container.querySelectorAll('[data-energy-modal]')).some((modal) => modal.classList.contains('is-visible'));
  }

  function closePreviews(container) {
    container.querySelectorAll('[data-energy-preview]').forEach((preview) => {
      setPreviewVisibility(preview, false);
    });
  }

  function closeModals(container, options) {
    const settings = options || {};
    const state = getState(container);
    const hadVisibleModal = hasVisibleModal(container);

    container.querySelectorAll('[data-energy-modal]').forEach((modal) => {
      setModalVisibility(modal, false);
    });

    container.querySelectorAll('[data-energy-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    if (hadVisibleModal && window.theme && theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
      theme.a11y.removeTrapFocus();
    }

    if (settings.returnFocus && state.activeModalTrigger) {
      state.activeModalTrigger.focus();
    }

    state.activeModalTrigger = null;
  }

  function closeAll(container, options) {
    closePreviews(container);
    closeModals(container, options);
  }

  function shouldDisablePreview(type) {
    return type === 'datasheet' && datasheetPreviewMobileQuery.matches;
  }

  function showPreview(container, type) {
    if (shouldDisablePreview(type)) {
      closePreviews(container);
      return;
    }

    const preview = getPreview(container, type);
    if (!preview) return;

    container.querySelectorAll('[data-energy-preview]').forEach((candidate) => {
      setPreviewVisibility(candidate, candidate === preview);
    });
  }

  function openModal(container, type, trigger) {
    const modal = getModal(container, type);
    if (!modal) return;

    const state = getState(container);
    const modalPanel = modal.querySelector('.energy-info__modal-panel');
    const closeButton = modal.querySelector('[data-energy-close]');

    closePreviews(container);
    closeModals(container);
    setModalVisibility(modal, true);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      state.activeModalTrigger = trigger;
    }

    if (modalPanel && window.theme && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
      theme.a11y.trapFocus(modalPanel, closeButton || modalPanel);
    }
  }

  function bindGlobalHandlers() {
    if (globalHandlersBound) return;
    globalHandlersBound = true;

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.energy-info').forEach((container) => {
        if (event.target instanceof Element && container.contains(event.target) && event.target.matches('[data-energy-modal]')) {
          closeAll(container, { returnFocus: true });
          return;
        }

        if (!container.contains(event.target)) {
          closeAll(container, { returnFocus: hasVisibleModal(container) });
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.energy-info').forEach((container) => {
        const shouldReturnFocus = hasVisibleModal(container);
        closeAll(container, { returnFocus: shouldReturnFocus });
      });
    });
  }

  function initEnergyInfo(container) {
    if (!container || container.dataset.energyInfoInitialized === 'true') return;

    container.dataset.energyInfoInitialized = 'true';
    bindGlobalHandlers();
    getState(container);

    container.querySelectorAll('[data-energy-trigger]').forEach((trigger) => {
      const type = trigger.dataset.energyTrigger;

      trigger.addEventListener('mouseenter', () => {
        showPreview(container, type);
      });

      trigger.addEventListener('focus', () => {
        showPreview(container, type);
      });
    });

    container.addEventListener('mouseleave', () => {
      closePreviews(container);
    });

    container.addEventListener('focusout', (event) => {
      if (!container.contains(event.relatedTarget)) {
        closePreviews(container);
      }
    });

    container.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-energy-close]');
      if (closeButton && container.contains(closeButton)) {
        event.preventDefault();
        closeAll(container, { returnFocus: true });
        return;
      }

      const trigger = event.target.closest('[data-energy-trigger]');
      if (trigger && container.contains(trigger)) {
        event.preventDefault();
        openModal(container, trigger.dataset.energyTrigger, trigger);
      }
    });
  }

  function initAllEnergyInfo() {
    document.querySelectorAll('.energy-info').forEach((container) => {
      initEnergyInfo(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllEnergyInfo);
  } else {
    initAllEnergyInfo();
  }

  if (window.theme && theme.pubsub && typeof theme.pubsub.subscribe === 'function') {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
      initAllEnergyInfo();
    });
  }
})();
